<div class="documents-manager">
  @if (showHeader && (heading || !readonly)) {
    <div class="documents-manager__header">
      <div class="documents-manager__heading">
        @if (heading) {
          <span class="documents-manager__title">{{ heading }}</span>
        }
        @if (hint) {
          <span class="documents-manager__hint">{{ hint }}</span>
        }
      </div>
      @if (!readonly) {
        <button
          pButton
          type="button"
          [label]="addButtonLabel"
          icon="pi pi-upload"
          class="p-button-outlined"
          (click)="openUploadDialog()"
        ></button>
      }
    </div>
  }

  <!-- Tabella documenti -->
  <p-table
    [value]="documents"
    [tableStyle]="{ 'min-width': '40rem' }"
    styleClass="p-datatable-sm"
    [paginator]="false"
    responsiveLayout="scroll"
    [attr.aria-label]="'Tabella documenti'"
  >
    <ng-template #header>
      <tr>
        <th style="width: 32%">Nome File</th>
        <th style="width: 28%">Titolo</th>
        <th style="width: 12%">Tipo</th>
        <th style="width: 16%">Data Caricamento</th>
        <th style="width: 12%" class="text-right">Azioni</th>
      </tr>
    </ng-template>
    <ng-template #body let-doc>
      <tr>
        <td>
          <div class="flex align-items-start gap-2">
            <i
              [class]="getFileIcon(doc.fileName)"
              [style.color]="
                getFileTypeSeverity(doc.fileName) === 'danger'
                  ? '#ef4444'
                  : getFileTypeSeverity(doc.fileName) === 'success'
                    ? '#22c55e'
                    : getFileTypeSeverity(doc.fileName) === 'warn'
                      ? '#f97316'
                      : '#3b82f6'
              "
              class="text-xl"
              aria-hidden="true"
            ></i>
            <span class="font-medium">{{ doc.fileName }}</span>
          </div>
        </td>
        <td>{{ doc.title || '—' }}</td>
        <td>
          <p-tag
            [value]="getFileExtension(doc.fileName)"
            [severity]="getFileTypeSeverity(doc.fileName)"
          ></p-tag>
        </td>
        <td>{{ doc.uploadDate || '—' }}</td>
        <td class="text-right">
          <div class="flex gap-2 justify-content-end">
            <p-button
              icon="pi pi-download"
              [rounded]="true"
              [text]="true"
              severity="secondary"
              size="small"
              (onClick)="download.emit(doc)"
              [ariaLabel]="'Scarica ' + doc.fileName"
              pTooltip="Scarica"
              tooltipPosition="top"
              title="Scarica"
            ></p-button>
            @if (!readonly) {
              <p-button
                icon="pi pi-trash"
                [rounded]="true"
                [text]="true"
                severity="danger"
                size="small"
                (onClick)="remove.emit(doc)"
                [ariaLabel]="'Elimina ' + doc.fileName"
                pTooltip="Elimina"
                tooltipPosition="top"
                title="Elimina"
              ></p-button>
            }
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="5" class="text-center py-4 text-color-secondary">
          <i class="pi pi-inbox text-4xl mb-3" style="display: block" aria-hidden="true"></i>
          {{ emptyMessage }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- ================= DIALOG: CARICA NUOVO DOCUMENTO ================= -->
<p-dialog
  [(visible)]="showUploadDialog"
  [modal]="true"
  [closable]="true"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="w-11 md:w-8 lg:w-6"
  [attr.aria-label]="'Dialog caricamento nuovo documento'"
  (onHide)="closeUploadDialog()"
>
  <ng-template #header>
    <div class="flex align-items-center gap-2">
      <i class="pi pi-upload text-xl" style="color: #00125b" aria-hidden="true"></i>
      <span class="text-xl font-semibold">{{ dialogHeader }}</span>
    </div>
  </ng-template>

  <div class="flex flex-column gap-4">
    <!-- Titolo Documento -->
    <div>
      <label for="dm-title" class="block mb-2 font-semibold">
        Titolo Documento @if (titleRequired) { <span class="text-red-600">*</span> }
      </label>
      <input
        id="dm-title"
        type="text"
        pInputText
        [(ngModel)]="newTitle"
        placeholder="Es. Allegato tecnico, Condizioni particolari, ecc."
        class="w-full"
        [disabled]="uploading"
        [attr.aria-required]="titleRequired"
        [attr.aria-invalid]="titleRequired && !newTitle().trim() ? 'true' : 'false'"
      />
      @if (titleRequired && !newTitle().trim()) {
        <small class="p-error block mt-1" role="alert">
          Inserisci un titolo descrittivo per il documento.
        </small>
      }
    </div>

    <!-- File Upload -->
    <div>
      <label id="dm-file-label" class="block mb-2 font-semibold">Seleziona File</label>
      <p-fileupload
        #fu
        name="dm-file"
        [auto]="false"
        [customUpload]="true"
        (uploadHandler)="onUploadHandler($event)"
        [accept]="accept"
        [maxFileSize]="maxFileSizeBytes"
        [disabled]="uploading"
        [showUploadButton]="false"
        [showCancelButton]="false"
        styleClass="custom-fileupload"
        [attr.aria-labelledby]="'dm-file-label'"
        class="w-full"
      >
        <ng-template pTemplate="header">
          <!-- Header vuoto per nascondere i pulsanti di default -->
        </ng-template>
        <ng-template
          pTemplate="content"
          let-files
          let-chooseCallback="chooseCallback"
          let-removeFileCallback="removeFileCallback"
        >
          @if (uploading) {
            <div class="flex align-items-center justify-content-center gap-2 p-5" role="status" aria-live="polite">
              <i class="pi pi-spin pi-spinner text-2xl" aria-hidden="true"></i>
              <span class="font-semibold">Caricamento in corso...</span>
            </div>
          } @else if (files && files.length === 0) {
            <div class="flex flex-column align-items-center justify-content-center p-5 text-center">
              <i class="pi pi-cloud-upload text-6xl mb-3 text-400" aria-hidden="true"></i>
              <p class="m-0 mb-2 font-semibold text-900">Trascina qui il documento</p>
              <p class="m-0 mb-3 text-sm text-600">oppure</p>
              <p-button
                label="Scegli File"
                icon="pi pi-folder-open"
                (onClick)="chooseCallback()"
                [outlined]="true"
                [attr.aria-label]="'Seleziona file da caricare'"
              ></p-button>
            </div>
          } @else {
            <div class="p-3">
              @for (file of files; track file.name) {
                <div class="flex align-items-center justify-content-between p-3 border-1 border-200 border-round mb-2">
                  <div class="flex align-items-center gap-3">
                    <i class="pi pi-file text-3xl text-primary" aria-hidden="true"></i>
                    <div>
                      <div class="font-semibold text-900">{{ file.name }}</div>
                      <small class="text-600">{{ formatFileSize(file.size) }}</small>
                    </div>
                  </div>
                  <p-button
                    icon="pi pi-times"
                    [rounded]="true"
                    [text]="true"
                    severity="danger"
                    (onClick)="removeFileCallback(file)"
                    [ariaLabel]="'Rimuovi ' + file.name"
                  ></p-button>
                </div>
              }
              <p-button
                label="Scegli un Altro File"
                icon="pi pi-folder-open"
                (onClick)="chooseCallback()"
                [outlined]="true"
                size="small"
                class="w-full mt-2"
                [attr.aria-label]="'Seleziona un file diverso da caricare'"
              ></p-button>
            </div>
          }
        </ng-template>
      </p-fileupload>
      <small class="text-600 block mt-2"><strong>Formati supportati:</strong> {{ formatsHint }}</small>
      <small class="text-600 block mt-1"><strong>Dimensione massima:</strong> {{ maxSizeHint }}</small>
    </div>
  </div>

  <ng-template #footer>
    <p-button
      label="Annulla"
      severity="secondary"
      [outlined]="true"
      icon="pi pi-times"
      (onClick)="closeUploadDialog()"
      [disabled]="uploading"
    ></p-button>
    <p-button
      label="Carica"
      icon="pi pi-check"
      (onClick)="fu.upload()"
      [loading]="uploading"
      [disabled]="
        uploading ||
        !fu.files ||
        fu.files.length === 0 ||
        (titleRequired && !newTitle().trim())
      "
    ></p-button>
  </ng-template>
</p-dialog>
